// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import {
  getWhyChooseUsApi,
  addWhyChooseUsApi
} from "../../../../services/Web/whyChooseUs.service"
import { toastError, toastSuccess } from "../../../../utility/toastutill"

// ** Get All WhyChooseUs Data
export const getAllWhyChooseUsData = createAsyncThunk(
  "whyChooseUs/getAllWhyChooseUsData",
  async () => {
    try {
      const response = await getWhyChooseUsApi()
      if (response.data.success) {
        toastSuccess(response.data.message)
      }
      return response.data.data
    } catch (error) {
      toastError(error)
      return error
    }
  }
)
// ** Add New WhyChooseUs 
// ** Add New WhyChooseUs
export const addWhyChooseUs = createAsyncThunk(
  "whyChooseUs`/addWhyChooseUs",
  async (formData, { dispatch, getState }) => {
    try {
      const res = await addWhyChooseUsApi(formData)
      if (res.data) {
        toastSuccess(res.data.message)
        await dispatch(getAllWhyChooseUsData(getState().whyChooseUs.params))
        await dispatch(getAllWhyChooseUsData())
      }
      return res.data.success ? res.data.success : false
    } catch (error) {
      toastError(error)
      return error
    }
  }
)

export const whyChooseUsSlice = createSlice({
  name: "whyChooseUs",
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedWhyChooseUs: null,
    success: false,
    loading: false,
    error: null
  },
  reducers: {
    clearSelectedWhyChooseUs: (state) => {
      state.selectedWhyChooseUs = null
    },
    clearError: (state) => {
      state.error = null
    },
    clearSuccess: (state) => {
      state.success = false
    }
  },
  extraReducers: (builder) => {
    builder
      // Get All WhyChooseUs Data
      .addCase(getAllWhyChooseUsData.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllWhyChooseUsData.fulfilled, (state, action) => {
        state.loading = false
        state.allData = action.payload
        state.data = action.payload
      })
      .addCase(getAllWhyChooseUsData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Add WhyChooseUs
      .addCase(addWhyChooseUs.pending, (state) => {
        state.loading = true
        state.success = false
      })
      .addCase(addWhyChooseUs.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(addWhyChooseUs.rejected, (state, action) => {
        state.loading = false
        state.success = false
        state.error = action.payload
      })
  }
})

export const { clearSelectedWhyChooseUs, clearError, clearSuccess } = whyChooseUsSlice.actions

export default whyChooseUsSlice.reducer